import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { ObjectType } from '@/@types/graphql-types';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { LinearTitleOffer } from '@/interfaces/buybox';
import GridOffer from '@/features/buybox/components/grid/GridOffer.vue';
import { useMounted, useNow } from '@vueuse/core';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { observableOptions } from '@/helpers/composables/useOfferImpressionTracking';
import { useExperiment } from '@/libraries/experiment';
import { sortAndDedupeOfferEpisodes } from '@/components/experiments/LinearTVExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearOfferExp',
  props: {
    title: null,
    offer: null,
    linearOffers: null,
    objectType: null,
    additionalContexts: null,
    inline: { type: Boolean },
    isBannerBuyBox: { type: Boolean }
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	offer: LinearTitleOffer;
	linearOffers: LinearTitleOffer[];
	objectType: ObjectType;
	additionalContexts?: SnowplowContext[];
	inline?: boolean;
	isBannerBuyBox?: boolean;
};





const isMounted = useMounted();
const { country, language } = storeToRefs(useLanguageStore());

// Live status
const now = useNow({ interval: 60000 });

const liveStatus = computed(() => {
	if (!isMounted.value) return false;

	const { availableFromTime, availableToTime } = props.offer;
	if (!availableFromTime || !availableToTime) return false;

	const from = new Date(availableFromTime).getTime();
	const to = new Date(availableToTime).getTime();
	if (Number.isNaN(from) || Number.isNaN(to)) return false;

	const nowMs = now.value.getTime();
	return from <= nowMs && nowMs < to;
});

const additionalEpisodes = computed(() => {
	return sortAndDedupeOfferEpisodes(props.offer.offerEpisodes ?? []).slice(1);
});

function getDate(dateTime: string | Date | null | undefined) {
	if (!dateTime) return '';
	const parsed = new Date(dateTime);
	if (isNaN(parsed.getTime())) return '';

	return new Intl.DateTimeFormat(`${language.value.split('-')[0]}-${country.value}`, {
		day: '2-digit',
		month: '2-digit',
	}).format(parsed);
}

const ESTTimeZone = 'America/New_York';
const DETimeZone = 'Europe/Berlin';

function getTime(dateTime: string | Date | null | undefined) {
	if (!dateTime) return '';
	const parsed = new Date(dateTime);
	if (isNaN(parsed.getTime())) return '';

	return new Intl.DateTimeFormat(`${language.value.split('-')[0]}-${country.value}`, {
		hour: '2-digit',
		minute: '2-digit',
		timeZone:
			country.value === 'US'
				? ESTTimeZone
				: country.value === 'DE'
				? DETimeZone
				: isMounted.value
				? Intl.DateTimeFormat().resolvedOptions().timeZone
				: 'UTC',
		timeZoneName: 'short',
		hourCycle: 'h23',
	}).format(parsed);
}

// EXP_LINEAR_TV
const { trackEvent } = useExperiment('EXP_LINEAR_TV');

const observeVisibilityOptions = computed(() => {
	return {
		callback: onVisibilityChanged,
		...observableOptions,
	};
});

function onVisibilityChanged(isVisible: boolean) {
	if (isVisible) trackEvent({ action: 'impression' });
}
// EXP_LINEAR_TV

return { __sfc: true,props, isMounted, country, language, now, liveStatus, additionalEpisodes, getDate, ESTTimeZone, DETimeZone, getTime, trackEvent, observeVisibilityOptions, onVisibilityChanged, GridOffer }
}

})